import { Auth } from 'aws-amplify';
const awsExports = {
  Auth: {
    // フェデレーションアイデンティティのID
    identityPoolId: process.env.VUE_APP_AWS_COGNITO_IDENTIFY_POOL_ID,

    // リージョン
    region: process.env.VUE_APP_AWS_REGION,

    // ユーザープールのID
    userPoolId: process.env.VUE_APP_AWS_COGNITO_USERPOOL_ID,

    // ユーザープールのウェブクライアントID
    userPoolWebClientId: process.env.VUE_APP_AWS_COGNITO_USERPOOL_CLIENT_ID,
    // ユーザー認証を強制
    mandatorySignIn: true,
  },
  API: {
    endpoints: [
      {
        // name: 'biomass-staging-stack',
        name: "biomass-stg-stack",
        endpoint: process.env.VUE_APP_AWS_API_ENDPOINT,
        region: "ap-northeast-1",
      },
    ],
  },
};

export default awsExports;
